import { Select, SelectContent, SelectGroup, SelectItem, SelectTrigger, SelectValue } from '@journ/ui/select'
import { useIntlayer } from 'react-intlayer'
import { useTheme } from '@/features/theme/hooks/use-theme'
import { useUserPreferences } from '@/features/preferences/hooks/use-user-preferences'
import type { Theme } from '@/features/theme/domain/theme'

const SunIcon = () => (
	<svg width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'>
		<circle cx='12' cy='12' r='4' /><line x1='12' y1='2' x2='12' y2='6' /><line x1='12' y1='18' x2='12' y2='22' />
		<line x1='4.22' y1='4.22' x2='7.05' y2='7.05' /><line x1='16.95' y1='16.95' x2='19.78' y2='19.78' />
		<line x1='2' y1='12' x2='6' y2='12' /><line x1='18' y1='12' x2='22' y2='12' />
		<line x1='4.22' y1='19.78' x2='7.05' y2='16.95' /><line x1='16.95' y1='7.05' x2='19.78' y2='4.22' />
	</svg>
)

const MoonIcon = () => (
	<svg width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'>
		<path d='M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z' />
	</svg>
)

const ThemeIcon = ({ theme }: { theme: 'light' | 'dark' }) => {
	if (theme === 'dark') return <MoonIcon />
	return <SunIcon />
}

const ThemeSwitch = () => {
	const content = useIntlayer('settings-general')
	const { theme, resolvedTheme, setTheme } = useTheme()
	const { updatePreferences } = useUserPreferences()

	const labels: Record<Theme, string> = {
		light: content.appearance.light.value,
		dark: content.appearance.dark.value,
		system: content.appearance.system.value,
	}

	const handleThemeChange = (value: Theme): void => {
		setTheme(value)
		void updatePreferences({ theme: value })
	}

	return (
		<div className='flex items-center relative'>
			<Select value={theme} onValueChange={handleThemeChange}>
				<SelectTrigger className='w-full pl-6 pr-3 py-0.5 bg-transparent outline-none capitalize h-[24px] text-xs border-0 shadow-none'>
					<SelectValue>{labels[theme]}</SelectValue>
				</SelectTrigger>
				<SelectContent>
					<SelectGroup>
						{(['light', 'dark', 'system'] as Theme[]).map(t => (
							<SelectItem key={t} value={t} className='capitalize text-xs'>
								{labels[t]}
							</SelectItem>
						))}
					</SelectGroup>
				</SelectContent>
			</Select>
			<div className='absolute left-2 pointer-events-none'>
				<ThemeIcon theme={resolvedTheme} />
			</div>
		</div>
	)
}

export { ThemeSwitch }